<template>
  <div v-if="$buttonAuthority(allButton, 'list')">
    <div class="search-class">
      <el-form
        :model="searchTxt"
        :inline="true"
        size="small"
        class="serarch-form"
      >
        <el-form-item label="模板名称">
          <el-input
            class="input-width-two"
            clearable
            v-model="searchTxt.templateName"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板内容">
          <el-input
            class="input-width-two"
            clearable
            v-model="searchTxt.templateContent"
          ></el-input>
        </el-form-item>
        <el-form-item label="添加人">
          <el-select
            class="input-width-two"
            v-model="searchTxt.createUserId"
            clearable
            filterable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="(val, key, index) in dropList.createUser"
              :label="val"
              :value="key"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板语种">
          <el-select
            class="input-width-two"
            v-model="searchTxt.templateLanguages"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(val, key, index) in dropList.templateLanguages"
              :label="val"
              :value="key"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-form-item label="模板类型">
            <el-select
              class="input-width-two"
              v-model="searchTxt.templateType"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(val, key, index) in dropList.templateType"
                :label="val"
                :value="key"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()" icon="el-icon-search"
              >查找</el-button
            >
            <el-button @click="reset()" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="main-table">
      <div class="table-header" style="margin-top: 15px">
        <add
          @getList="getList"
          class="button-class"
          :dropList="dropList"
          v-if="$buttonAuthority(allButton, 'add')"
        ></add>
      </div>
      <commonTable
        :loading="loading"
        :tableData="tableData"
        :tableLabel="tableLabel"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="pagination.pageSize"
        :currentPage="pagination.page"
        :total="pagination.total"
        :tableOption="tableOption"
        @handleButton="handleButton"
      ></commonTable>
    </div>
    <div v-if="isEdit">
      <edit
        :scope="scope"
        @getList="getList"
        @isShowEdit="isShowEdit"
        :dropList="dropList"
      ></edit>
    </div>
    <div v-if="isLog">
      <logLook
        :modelName="modelName"
        :logType="logType"
        :id="scope.id"
        @lookClick="isShowEdit"
      ></logLook>
    </div>
  </div>
</template>
<script>
/**
 * 邮件回复模板配置列表页
 * 功能：按模板名称、内容、添加人、语种、类型筛选，支持新增、编辑、删除、日志查看
 */
import { getTemplateList, templateDelete } from "@/api/user";
import add from "./components/add";
import edit from "./components/edit";
export default {
  components: { add, edit },
  data() {
    return {
      // 日志查询模型名
      modelName: "config",
      // 日志类型
      logType: "template",
      // 列表加载中状态
      loading: true,
      isshowhidden: false,
      isEdit: false,
      isFirst: true,
      isLog: false,
      // 编辑/日志弹窗回填的行数据
      scope: [],
      hiddenHeader: [],
      // 页面按钮权限列表
      allButton: [],
      // 列表数据
      tableData: [],
      // 表格列定义
      tableLabel: [],
      // 表头映射
      titleMap: [],
      // 下拉数据（语种、类型、创建人）
      dropList: {},
      // 下拉渲染数据
      renderList: {},
      tableOption: {
        label: "操作",
        minWidth: "150",
        fixed: "right",
        options: [
          {
            label: "编辑",
            type: "text",
            methods: "edit",
            size: "mini",
          },
          {
            label: "删除",
            type: "text",
            methods: "delete",
            size: "mini",
          },
          {
            label: "日志",
            type: "text",
            methods: "log",
            size: "mini",
          },
        ],
      },
      // 搜索条件（模板名称、内容、添加人、语种、类型）
      searchTxt: {
        templateName: "",
        templateContent: "",
        createUserId: "",
        templateLanguages: "",
        templateType: "",
      },
      // 分页参数
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  // 空钩子（模板残留，无逻辑）
  mounted() {},
  /**
   * 页面激活时拉取按钮权限并查询列表、过滤操作列权限
   */
  activated() {
    this.allButton = this.$getStorage(this.$route.name + "_button");
    if (this.$buttonAuthority(this.allButton, "list")) {
      this.getList();
      this.tableOptionAuth();
    }
  },
  methods: {
    /** 生成表格列定义，按固定下标删除第 5 列并将第 7 列替换为创建人列（硬编码下标） */
    getTableLabel() {
      this.tableLabel = this.$getTableLabel(this.titleMap, this.renderList);
      let createUser = {
        label: "创建人",
        param: "createUser",
        align: "center",
        show: true,
        render: (h, param) => {
          let str = this.$getText(
            param.row.createUser,
            this.renderList.createUser
          );
          return h("div", [str]);
        },
      };
      this.tableLabel.splice(4,1)
      this.tableLabel.splice(6,1,createUser)
      this.loading = false;
    },
    /** 查询邮件模板列表 */
    getList() {
      this.loading = true;
      getTemplateList(this.pagination).then((result) => {
        if (result.code == 200) {
          this.tableData = result.data.pageInfo.records;
          this.pagination.total = result.data.pageInfo.total;
          let label = result.data.renderList;
          this.dropList = result.data.dropList;
          if (label == null) {
            this.renderList = {};
          } else {
            Object.assign(this.renderList, label);
          }
          if (this.isFirst) {
            this.titleMap = result.data.titleMap;
            this.getTableLabel();
          } else {
            this.loading = false;
          }
        }
      });
    },
    /**
     * 操作列按钮分发（编辑/删除/日志）
     * @param {Object} data 操作事件数据，含 methods 与行数据 row
     */
    handleButton(data) {
      var funType = data.methods;
      if (funType === "edit") {
        this.editInfo(data.row);
      } else if (funType === "delete") {
        this.deleteInfo(data.row);
      } else if (funType === "log") {
        this.logInfo(data.row);
      }
    },
    /** 关闭编辑与日志弹窗 */
    isShowEdit() {
      this.isEdit = false;
      this.isLog = false;
    },
    /**
     * 删除模板（二次确认后调用删除接口）
     * @param {Object} data 行数据，含 id
     */
    deleteInfo(data) {
      this.$confirm("确定删除选中的内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: data.id,
          };
          templateDelete(param)
            .then((result) => {
              if (result.code == 200) {
                this.$message.success("删除成功");
                this.getList();
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    /** 打开编辑弹窗并回填行数据 */
    editInfo(data) {
      this.scope = data;
      this.isEdit = true;
    },
    /** 打开操作日志弹窗并回填行数据 */
    logInfo(data) {
      this.scope = data;
      this.isLog = true;
    },
    /** 分页大小变化时重置到第一页并重新查询 */
    handleSizeChange(value) {
      this.pagination.pageSize = value;
      this.pagination.page = 1;
      this.getList();
    },
    /** 当前页码变化时重新查询 */
    handleCurrentChange(value) {
      this.pagination.page = value;
      this.getList();
    },
    /** 按按钮权限过滤操作列配置 */
    tableOptionAuth() {
      let array = this.tableOption.options;
      let authOption = [];
      array.forEach((element) => {
        if (this.$buttonAuthority(this.allButton, element.methods)) {
          authOption.push(element);
        }
      });
      if (authOption.length > 0) {
        this.tableOption.options = authOption;
      } else {
        this.tableOption = {};
      }
    },
    /** 按搜索条件查询列表，添加人多选数组转逗号字符串提交 */
    search() {
      this.pagination.page = 1;
      Object.assign(this.pagination, this.searchTxt);
      const id = this.searchTxt.createUserId;
      if (id) {
        this.pagination.createUserId = id.join(",");
      }
      this.isFirst = false;
      this.getList();
    },
    /** 重置搜索条件并重新查询 */
    reset() {
      this.pagination.page = 1;
      this.$delectObj(this.searchTxt, [
        "templateName",
        "templateContent",
        "createUserId",
        "templateLanguages",
        "templateType",
      ]);
      this.$delectObj(this.pagination, [
        "templateName",
        "templateContent",
        "createUserId",
        "templateLanguages",
        "templateType",
      ]);
      this.isFirst = false;
      this.getList();
    },
  },
};
</script>

<style scoped>
</style>